import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3 border-t border-gray-100 px-3.5 py-2.5 text-xs" }
const _hoisted_2 = { class: "flex-1 text-gray-600" }
const _hoisted_3 = ["disabled"]

import { ArrowUturnLeftIcon } from '@heroicons/vue/20/solid'
import { ref } from 'vue'


export default {
  __name: 'ResetButton',
  props: {
  disabled: { type: Boolean, default: false },
  question: { type: String, default: 'Put everything here back to the default?' }
},
  emits: ['reset'],
  setup(__props, { emit: __emit }) {



const emit = __emit

const confirming = ref(false)

const reset = () => {
  confirming.value = false
  emit('reset')
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (confirming.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.question), 1),
          _createElementVNode("button", {
            type: "button",
            class: "font-medium text-gray-500 hover:text-gray-900",
            onClick: _cache[0] || (_cache[0] = $event => (confirming.value = false))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "font-semibold text-red-600 hover:text-red-700",
            onClick: reset
          }, "Reset")
        ], 64))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "inline-flex items-center gap-1 font-medium text-gray-500 hover:text-gray-900 disabled:cursor-default disabled:text-gray-300",
          disabled: __props.disabled,
          onClick: _cache[1] || (_cache[1] = $event => (confirming.value = true))
        }, [
          _createVNode(_unref(ArrowUturnLeftIcon), {
            class: "h-3.5 w-3.5",
            "aria-hidden": "true"
          }),
          _cache[2] || (_cache[2] = _createTextVNode(" Reset to defaults ", -1))
        ], 8, _hoisted_3))
  ]))
}
}

}